import { login, logout, getInfo, getSingleUserInfo, checkList } from '@api/user'
import { getToken, setToken, removeToken } from '@utils/auth'
import {
  setAccount,
  deleteAccount,
  setPassword,
  deletePassword,
} from '@utils/auth'
import { SUCCESS } from '@config/code'

const user = {
  state: {
    curPatient: {
      uid: '',
      gender: '',
      age: '',
      fullName: '默认患者',
    },
    patientMedicalRecord: [{}],
    token: getToken(),
    userInfo: {},
    advice: [],
  },
  mutations: {
    setToken: (state, token) => (state.token = token),
    setUsername: (state, userName) => (state.userName = userName),
    setHosipitalId: (state, hid) => (state.hid = hid),
    setDoctorId: (state, did) => (state.did = did),
    setHosipitalName: (state, hospitalName) => {
      state.hospitalName = hospitalName
    },
    setPetmittedExamList: (state, examineList) => {
      state.examineList = examineList
    },
    setUserSetting: (state, setting) => (state.setting = setting),
    setCurrentPatient: (state, curPatient) => {
      state.curPatient = {
        uid: curPatient.uid,
        gender: curPatient.gender,
        age: curPatient.age,
        fullName: curPatient.fullName,
        userName: curPatient.fullName,
      }
    },
    clearCurPatient: state => {
      state.curPatient = {
        uid: '',
        gender: '',
        age: '',
        fullName: '默认患者',
      }
    },
    setPatientMedicalRecord: (state, record) => {
      state.patientMedicalRecord = record
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
      // setUserInfoInCookies(state.userInfo)
    },
    setAdvice: (state, advice) => {
      state.advice = advice
    },
  },
  actions: {
    async _Login({ dispatch, commit, state }, loginForm) {
      return new Promise((resolve, reject) => {
        login({
          account: loginForm.account,
          password: loginForm.password,
          // source:'bhs',
        })
          .then(response => {
            if (response.code === SUCCESS) {
              if (loginForm.remember) {
                setAccount(loginForm.account)
                setPassword(loginForm.password)
              } else {
                deleteAccount()
                deletePassword()
              }
              setToken(response.token)
              commit('setToken', response.token)
              resolve(response)
              // dispatch('_GetInfo')
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
      // const response = await login({
      //   account: loginForm.account,
      //   password: loginForm.password,
      // })
      // if (response.code === SUCCESS) {
      //   if (loginForm.remember) {
      //     setAccount(loginForm.account)
      //     setPassword(loginForm.password)
      //   } else {
      //     deleteAccount()
      //     deletePassword()
      //   }
      //   setToken(response.token)
      //   commit('setToken', response.token)
      //   dispatch('_GetInfo')
      // }
    },
    async _GetInfo({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then(data => {
            data.examineList = data.checkList
            commit('setUserInfo', data)

            resolve(data)
          })
          .then(() => {
            dispatch('GetDecsion')
          })
          .catch(error => {
            console.log(error)
          })
      })
    },

    async GetPatienInfo({ dispatch, commit }, uid) {
      const patientInfo = await getSingleUserInfo(uid)
      commit('setCurrentPatient', patientInfo)
    },
    async GetPatientMedicalRecord({ commit, state }, uid) {
      if (!uid || state.curPatient.uid === '') {
        return
      }
      try {
        let params = {
          uid: uid || state.curPatient.uid,
          // limit: 1,
          page: 1,
          type: 'check',
        }
        const res = await checkList(params)
        commit('setPatientMedicalRecord', res.data)
      } catch (error) {
        console.log(error)
      }
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('setToken', '')
            removeToken()
            // deleteUserInfoAccount()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('setToken', '')
        removeToken()
        resolve()
      })
    },
  },
  getters: {
    isdefaultPatient: state => state.curPatient.fullName === '默认患者',
  },
}

export default user
